import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './header.css';
import { Link} from 'react-router-dom'; 

function Header() {
  return (
    <div className='container'>
      <div className="row">
        <div className="col-12 col-lg-2 col-xl-2 headerBrand text-center"> 
        <a href="/" className="menuBrand">Iuliana Mihai</a>
        </div>
        <div className="col-12 col-lg-9 col-xl-9 headerSocial text-center">
          <a href="/" className="menuItem">Home</a>
          <Link to="/about" className="menuItem">About me </Link>
          <Link to="/presetsluts" className="menuItem">Presets and Luts </Link>
          <Link to="/travel" className="menuItem">Travel </Link>
          <Link to="/portfolio" className="menuItem">Portfolio </Link>
          <Link to="/contact" className="menuItem">Contact </Link>
        </div>
      </div>
    </div>
  );
}

export default Header;